import React from 'react';
import FieldShell from './FieldShell';

export default function TextAreaField({
  label,
  helpText,
  error,
  inputId,
  width,
  tapTarget,
  startAdornment,
  endAdornment,
  ...rest
}) {
  const control = <textarea {...rest} />;
  const shouldWrapWithShell = !!(label || helpText || error || inputId || width || tapTarget || startAdornment || endAdornment);
  if (!shouldWrapWithShell) {
    return control;
  }

  return (
    <FieldShell
      label={label}
      helpText={helpText}
      error={error}
      inputId={inputId}
      width={width}
      tapTarget={tapTarget}
      startAdornment={startAdornment}
      endAdornment={endAdornment}
    >
      {control}
    </FieldShell>
  );
}
